import gql from 'graphql-tag'

const JobPartsFragment = gql`
  fragment JobParts on Job {
    id
    visible
    type
    args
    project {
      id
      name
    }
    notify
    status
    progress
    validation
    attachment {
      data_file_name
      url
    }
    created_at
  }
`

export const GET_JOBS = gql`
  query JobsFetchQuery {
    user_jobs {
      ...JobParts
    }
  }
${JobPartsFragment}
`
export const JOB_SUBSCRIPTION = gql`
  subscription onNewJob {
    newJob {
      ...JobParts
    }
  }
${JobPartsFragment}
`
export const JOBS_NOTIFY_OFF = gql`
  mutation notifyOffJobs {
    notifyOffJobs {
      response
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/JobsNotifications/graphql.js